// third-party
import { combineReducers } from "redux";

// project-imports
import menu from "./menu";
import RegisterOwnerBrandReducer from "./registerbrandowner";
import registerBrandUser from "./registerbranduser";
import CreateRolssseeeReducer from "./createrole";
import ViewAllRolesReduncerre from "./viewallrole";
import AssignPermisionsReducer from "./assignpermissions";
import GetAllPermissionReducer from "./getallassignpermissions";
import ViewAllRedUsers from "./viewAllUsers";
import EditUserDataReducer from "./edituser";
import ViewallBrandssRedUsers from "./viewallbrand";
import BrandDetailsGetDataReducer from "./detailbrandedit";
import AllGetCateeReducers from "./allcategeory";
import SubAllCateReducers from "./allsubcategries";
import AllCompaniesReducers from "./allcompany";
import AllCountReducers from "./allcount";
import CompanyDetailingReducer from "./companydetails";
import AllProducts from "./allProducts";
import AllActiveCompanies from "./AllActiveCompanies";
import AllRandomCode from "./allRandom";
import AllActiveBrands from "./allActiveBrands";
import AllActiveProducts from "./allActiveProducts";
import GetRolePermissions from "./rolePermissions";
import AllBatchesReducers from "./allBatches";
import AllSmsLogs from "./allsmslog";
import Reports from "./reports";
import SMSReply from "./smsreply";
import ColorShift from "./ColorShift";
import DomainParameter from "./DominParameter";
import ExportReducerCsv from "./exportcsv";
import CSvCompanyReducer from "./csvcompany";
import CSVCategories from "./exportcsvcategory";
import AllCsvRadmon from "./exportcsvrandomcode";
import CSvQRReducer from "./csvQRcode";
import ReportProblemReducer from "./ReportProblemReducer";
import ProgressReducer from "./ProgressCode";
import MapDataReducers from "./mapdata";
import PostPreDataReduncers from "./prepostdataredd";
import AllCustomBatchReducers from "./allCustomBatch";
import AllCustomerReducer from "./allCustomer";
import ActiveCustomerAll from "./allActiveCustomer";
import AllBatchesBothGet from "./allBatchesboth";
import CustomBatchExportData from "./custombatchexport";
import FetchedCode from "./fetchedcode";
import GetAllBrandOwnerReducer from './brandownerclientred'
import CreatTokenDataReducers from './create-token'
import GetAllBrandCLientDataToekns from './brandclienttokens'
import AllOAuthCompanyDataRed from './allcompaniesoauth'
import AllViewProject_reducer from './allProjectsNew';
import {
    Buildings_reducer,
    Manufacturers_reducer,
    CapacityUoms_reducer,
    TagConditions_reducer,
    Departments_reducer,
    Floors_reducer,
    Rooms_reducer,
    PhotoTypes_reducer,
    Conditions_reducer,
    AssetDescriptions_reducer,
    ExistingAssets_reducer,
    CustomAttributes_reducer,
} from './masterDataReducers';
import {
    DashboardProgress_reducer,
    DashboardCollectorProgress_reducer,
    DashboardLocationProgress_reducer,
    DashboardQuality_reducer,
    DashboardStatusFunnel_reducer,
    DashboardMap_reducer,
} from './dashboardReducers';
import ProjectAssetsDownload_reducer from './projectAssetsDownload';

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
    menu,
    RegisterOwnerBrandReducer,
    registerBrandUser,
    CreateRolssseeeReducer,
    ViewAllRolesReduncerre,
    AssignPermisionsReducer,
    Reports,
    GetAllPermissionReducer,
    ViewAllRedUsers,
    AllBatchesReducers,
    EditUserDataReducer,
    ViewallBrandssRedUsers,
    BrandDetailsGetDataReducer,
    AllGetCateeReducers,
    SubAllCateReducers,
    AllCompaniesReducers,
    AllCountReducers,
    CompanyDetailingReducer,
    AllActiveCompanies,
    AllProducts,
    AllRandomCode,
    AllActiveBrands,
    AllActiveProducts,
    GetRolePermissions,
    AllSmsLogs,
    SMSReply,
    ColorShift,
    DomainParameter,
    ExportReducerCsv,
    CSvCompanyReducer,
    CSVCategories,
    AllCsvRadmon,
    CSvQRReducer,
    ReportProblemReducer,
    ProgressReducer,
    MapDataReducers,
    PostPreDataReduncers,
    AllCustomBatchReducers,
    AllCustomerReducer,
    ActiveCustomerAll,
    AllBatchesBothGet,
    CustomBatchExportData,
    FetchedCode,
    GetAllBrandOwnerReducer,
    CreatTokenDataReducers,
    GetAllBrandCLientDataToekns,
    AllOAuthCompanyDataRed,
    AllViewProject_reducer,
    Buildings_reducer,
    Manufacturers_reducer,
    CapacityUoms_reducer,
    TagConditions_reducer,
    Departments_reducer,
    Floors_reducer,
    Rooms_reducer,
    PhotoTypes_reducer,
    Conditions_reducer,
    AssetDescriptions_reducer,
    ExistingAssets_reducer,
    CustomAttributes_reducer,
    DashboardProgress_reducer,
    DashboardCollectorProgress_reducer,
    DashboardLocationProgress_reducer,
    DashboardQuality_reducer,
    DashboardStatusFunnel_reducer,
    DashboardMap_reducer,
    ProjectAssetsDownload_reducer,
});

export default reducers;
